import { Box, Grid } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useOtbPlan from '@hook/Otb/use-plan'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'

import { disableActionsByDefault } from '@helper/otb/plan/disableActionsByDefault'
import { scalesHeightOtbTable } from '@helper/otb/plan/scalesHeightOtbTable'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const OtbPlan: FC = () => {
  const { hasSessions } = useSessions()
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    data,
    query,
    params,
    filters,
    loading,
    actions,
    headers,
    filename,
    fetching,
    filtersList,
    finalStorage,
    tableInteraction,
    handleLocalParams,
    loadingUpdateGrid,
    getData,
    setQuery,
    setFilters,
    setFilename,
    exportKpiData,
    clearAllFilters,
    handleUpdateParams,
    handleSaveUpdateGrid,
    handleUpdateFinalStorage,

    dataFooter
  } = useOtbPlan()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () => scalesHeightOtbTable({ menuToggle, isGraphic: false, hasSessions }),
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          handleLocalParams()
          getFilters({
            periods: true,
            companies: true,
            worlds: true,
            compactCategories: true,
            categories: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="OTB Plano">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
        isDisabled={loading || fetching || data.length === 0}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onClick={exportKpiData}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data?.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <GridQuantity
                data={data}
                textButton="Salvar"
                disabled={finalStorage.planos.length === 0}
                isLoading={loadingUpdateGrid}
                onClick={handleSaveUpdateGrid}
              />

              <TableGrid
                id="plan-table"
                entity="otb-plan"
                data={data}
                query={query}
                headers={headers}
                loading={fetching}
                itsSortable={true}
                height={tableHeight}
                isActions={false}
                actions={tableInteraction}
                updatedFinalStorage={handleUpdateFinalStorage}
                dataFooter={dataFooter}
                isFooter={true}
                isPaged
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default OtbPlan
